import { ChipList } from "components";
import { Typography } from "@mui/material";

interface IProps {
    callOffCodes: string[];
    deletable?: boolean;
    title?: string;
    emptyCallOffCodeTitle?: string;
    style?: React.CSSProperties;
    onDeleted?: (newItems: string[], deletedItem: string, deletedItemIndex: number) => void;
}

const CallOffCodeChips = (props: IProps) => {
    const { callOffCodes, deletable, onDeleted, title, emptyCallOffCodeTitle, style } = props;

    return (
        <div style={style}>
            {callOffCodes?.length > 0 && title && (
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    {title}
                </Typography>
            )}
            {callOffCodes?.length === 0 && emptyCallOffCodeTitle && (
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    {emptyCallOffCodeTitle}
                </Typography>
            )}
            <ChipList
                labelId="call-off-code-chip-label"
                labelAriaLabel="call-off-code-chip-label"
                deleteButtonId="call-off-code-chip-delete-button"
                deleteButtonAriaLabel="call-off-code-chip-delete-button"
                items={callOffCodes}
                deletable={deletable}
                onDeleted={onDeleted}
            />
        </div>
    );
};

export default CallOffCodeChips;
